import { render } from "./ContentSidebarWrapper.vue?vue&type=template&id=6f0130d0&ts=true"
import script from "./ContentSidebarWrapper.vue?vue&type=script&lang=ts"
export * from "./ContentSidebarWrapper.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ContentSidebarWrapper.vue?vue&type=style&index=0&id=6f0130d0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__